'use client';

import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import type { ImageProps } from 'next/image';
import Image from 'next/image';
import type { OrderPaymentImageOption } from '@packages/config/src/default/order/order.types';

export interface PaymentImageProps extends Omit<ImageProps, 'src' | 'alt'> {
  className?: string;
  option: OrderPaymentImageOption;
}

const altByOption: Record<OrderPaymentImageOption, string> = {
  amex: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  klarna_sofort: 'Klarna Sofort',
  mastercard: 'Mastercard',
  paydirekt: 'Paydirekt',
  paypal: 'Paypal',
  ideal: 'iDEAL',
  visa: 'Visa',
  mastercard_clicktopay: 'Mastercard Click to Pay',
  visa_clicktopay: 'Visa Click to Pay',
  clicktopay: 'Click to Pay',
  wero: 'Wero',
};

export const PaymentImage: React.FC<PaymentImageProps> = ({
  className,
  option,
  width = 48,
  height = 32,
  ...args
}) => {
  const {
    assets: { assetServerHost },
  } = useConfig();
  const imageSrc = `${assetServerHost}/i/empiriecom/${option}.svg`;

  return (
    <Image
      className={className}
      src={imageSrc}
      alt={altByOption[option]}
      width={width}
      height={height}
      {...args}
    />
  );
};
